import { render } from "./TruckCard.vue?vue&type=template&id=fc120c4c"
import script from "./TruckCard.vue?vue&type=script&lang=js"
export * from "./TruckCard.vue?vue&type=script&lang=js"

import "./TruckCard.vue?vue&type=style&index=0&id=fc120c4c&lang=scss"

import exportComponent from "/opt/build/repo/access-trucks/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__